const mockDetails = {
    price: '$9.99',
    isEligibleForLeadGuarantee: true,
};

const mockDetailsWithMetroidProductList = {
    ...mockDetails,
    isFlatFeeEnabled: false,
    products: [
        {
            type: 1,
            paymentValidDuration: 'week',
            price: '$9.99',
            isEligibleForLeadGuarantee: true,
        },
        {
            type: 2,
            paymentValidDuration: '90 days',
            price: '$30',
            isEligibleForLeadGuarantee: false,
        },
    ],
};

export {
    mockDetails,
    mockDetailsWithMetroidProductList,
};
